module.exports = __webpack_public_path__ + "img/perdidaUbicacionGps.accbc131.svg";